import { CapoPlugin } from "/Users/pavel/Work/xsquare-2024/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];